import { useMutation } from 'react-query'

import { languagesService } from 'src/services/languages.service'
import { ETranslationType } from 'src/types/generate-localization.type'

export const useUpdateAITranslation = (translationId: string) => {
  return useMutation((type?:ETranslationType) => languagesService.updateAITranslation(translationId, type ?? ETranslationType.TITLE))
}
